// redux/slices/addressSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  addAddressService,
  showAddressService,
  editAddressService,
  deleteAddressService, // Import edit address API function
} from "../services/addressServices";

// Async action to add an address
export const addAddress = createAsyncThunk(
  "address/addAddress",
  async (addressData, { rejectWithValue }) => {
    try {
      const response = await addAddressService(addressData);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Async action to fetch addresses
export const fetchAddresses = createAsyncThunk(
  "address/fetchAddresses",
  async (_, { rejectWithValue }) => {
    try {
      const response = await showAddressService();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Async action to edit an address
export const editAddress = createAsyncThunk(
  "address/editAddress",
  async (updatedData, { rejectWithValue }) => {
    try {
      const response = await editAddressService(updatedData);
      return { updatedData: response }; // Return ID + updated data
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// Async action to delete an address
export const deleteAddress = createAsyncThunk(
  "address/deleteAddress",
  async (id, { rejectWithValue }) => {
    try {
      await deleteAddressService(id);
      return id; // Return deleted address ID
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const addressSlice = createSlice({
  name: "address",
  initialState: {
    addresses: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle add address
      .addCase(addAddress.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAddress.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.addresses.push(action.payload);
        }
      })
      .addCase(addAddress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Handle fetch addresses
      .addCase(fetchAddresses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAddresses.fulfilled, (state, action) => {
        state.loading = false;
        state.addresses = action.payload;
      })
      .addCase(fetchAddresses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Handle edit address
      .addCase(editAddress.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editAddress.fulfilled, (state, action) => {
        state.loading = false;
        const { id, updatedData } = action.payload;
        state.addresses = state.addresses.map((address) =>
          address.id === id ? { ...address, ...updatedData } : address
        );
      })
      .addCase(editAddress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //handle delete address
      // Handle delete address
      .addCase(deleteAddress.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAddress.fulfilled, (state, action) => {
        state.loading = false;
        state.addresses = state.addresses.filter(
          (address) => address.id !== action.payload
        );
      })
      .addCase(deleteAddress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default addressSlice.reducer;
